import { Dispatch } from 'redux';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction, HttpMethods } from '../models/api-model';
import { apiAction } from './base-api';

export const getEmployerChangeLogs = (groupId: number, payload: any, onSuccess: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.changeLogApi}/events/group/${groupId}/changelog`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};


export const getEmployerChangeLogDetail = (changeId: string, onSuccess: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.mlps}/history/change_request/${changeId}`,
		onSuccess,
		onFailure,
	});
};
